import {handleRes} from './responseUtil';
import {toPage, openInNewWindow} from './routerUtils';
import {getDictList,getDictName} from './dictUtil';
import {getResetForm} from './form-util'
import {versionCompare} from './upgradeUtil'
import axios from 'axios';

// 文件转arrayBuffer
const fileToBinary = (file: any) => {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onloadend = function() {
        const binaryData = fileReader.result;
        // handle binary data
        resolve(binaryData)
      };
    } catch (err) {
      reject(err)
    }
  })
}

// oss上传文件的方法
const ossUplaodFile = (uploadurl: string, file: any) => {
  return new Promise(async (resolve, reject) => {
    const fileBanary = await fileToBinary(file);
    axios.put(uploadurl, fileBanary,{
      responseType: "blob",
      headers: {
          "Content-Type": " application/octet-stream"
        }
      }).then(async res => {
        if (+res.status === 200) {
          resolve({
            code: 200,
            message: '上传成功'
          })
        } else {
          reject()
        }
      }).catch((err) => {
        reject(err)
      })
  })
}

/** 项目 i18n locale -> 后端权限多语言 key */
const mapAppLocaleToPermissionLang = (locale?: string): string => {
  const m: Record<string, string> = {
    'zh-cn': 'zh-CN',
    'zh-tw': 'zh-TW',
    en: 'en'
  };
  if (!locale) return 'zh-CN';
  return m[locale] || 'zh-CN';
};

/** 控件权限行展示用 label：pageName + 当前语言的 pageNameLanguage */
const buildControlPermissionRowLabel = (item: any, backendLang: string) => {
  const segA = item.pageName;
  const segB =
    item.pageNameLanguage && typeof item.pageNameLanguage === 'object'
      ? item.pageNameLanguage[backendLang] ?? item.pageName
      : item.pageName;
  if (!segA || segA === segB) return segB || segA || '';
  return `${segA}-${segB}`;
};

// 权限分类方法
const authClassify = (data: any, locale?: string) => {
  const resTree = []
  // 默认 sort 值，用于缺失 sort 字段的项
  const DEFAULT_SORT = 999999;
  const permissionLang = mapAppLocaleToPermissionLang(locale);
  
  // 构建一级菜单分组，并记录每个分组的最小 sort 值
  data.forEach((item: any, i: Number) => {
    const existingGroup = resTree.find(item2 => item2.name === item.menuName);
    if (!existingGroup) {
      // 获取当前项的 sort 值，缺失则使用默认值
      const itemSort = item.sort !== undefined && item.sort !== null ? item.sort : DEFAULT_SORT;
      resTree.push({
        name: item.menuName,
        checked: false,
        children: [],
        minSort: itemSort // 记录该分组的最小 sort 值
      })
    } else {
      // 如果已存在分组，更新最小 sort 值
      const itemSort = item.sort !== undefined && item.sort !== null ? item.sort : DEFAULT_SORT;
      if (itemSort < existingGroup.minSort) {
        existingGroup.minSort = itemSort;
      }
    }
  })
  
  // 按最小 sort 值对一级菜单进行排序
  resTree.sort((a, b) => a.minSort - b.minSort);
  
  const res = resTree.map((e, i) => {
    // 先辈们的历史遗留，name（上一步接口返回的menuName）作为一级菜单id
    e.vIdName = e.name
    e.id = i;
    
    // 获取该分组下的所有子菜单
    const children = data.filter(ele => e.name === ele.menuName);
    
    // 对二级菜单按 sort 值升序排序
    children.sort((a: any, b: any) => {
      const sortA = a.sort !== undefined && a.sort !== null ? a.sort : DEFAULT_SORT;
      const sortB = b.sort !== undefined && b.sort !== null ? b.sort : DEFAULT_SORT;
      return sortA - sortB;
    });
    
    e.children = children;
    e.checked = !e.children.find(ele => !ele.enable)
    e.disable = !e.children.find(ele => ele.operate)

    const controlRows = data.filter(
      (ele: any) =>
        e.name === ele.menuName &&
        ele.controlPermission != null &&
        ele.controlPermission !== ''
    );
    controlRows.sort((a: any, b: any) => {
      const sortA = a.sort !== undefined && a.sort !== null ? a.sort : DEFAULT_SORT;
      const sortB = b.sort !== undefined && b.sort !== null ? b.sort : DEFAULT_SORT;
      return sortA - sortB;
    });
    controlRows.forEach((row: any) => {
      row.label = buildControlPermissionRowLabel(row, permissionLang);
    });
    e.controlPermissionList = controlRows;
    
    // 清理临时属性
    delete e.minSort;
    
    return e
  })
  return res;
}

const classifyDict = function(data: any){
  // 初始化字典  paln-B
  let parentDict = data.filter((o: any) => (o.dictTypeCode === "" || o.dictTypeCode === null))
  let childDict = data.filter((o: any) => (o.dictTypeCode != "" && o.dictTypeCode != null))
  let result = {}
  parentDict.forEach((item: any)=>{
    item.childList = childDict.filter((o: any) => (o.dictTypeCode === item.dictCode));
    result[item.dictCode] = item
  })
  return result;
}

const resourceUrlConnect = (relativePath:string)=>{
  const relativePathFmt = relativePath.startsWith('/') ? relativePath : `/${relativePath}`
  const host = location.protocol === 'http' ? window.config.resourceHostHttp : window.config.resourceHostHttps
  const hostFmt = host.endsWith('/') ? host.slice(0, -1) : host
  return `${hostFmt}${relativePathFmt}`
}


export {
  handleRes,
  getDictList,
  getDictName,
  toPage,
  openInNewWindow,
  fileToBinary,
  ossUplaodFile,
  authClassify,
  classifyDict,
  getResetForm,
  versionCompare,
  resourceUrlConnect
};

